
import { QueryCache } from "@tanstack/react-query";
import { MutationCache } from "@tanstack/react-query";

import Cookies from "js-cookie";

export const queryErrorHandler = (error) => {
  if (error?.status === 422) {
    console.error("Unauthorized. Clearing storage and redirecting.");
    Cookies.remove("token");
    localStorage.clear();
    // window.location.href = "/"; // or use `navigate("/")` if within a component
    
  }
};

export const queryCache = new QueryCache({
  onError: queryErrorHandler,
});


export const mutationCache = new MutationCache({
  onError: queryErrorHandler,
});
